import { dataStateAtom } from '@store/atoms'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
//import { useAppContext } from './use-app-context'

export function useModUnico() {
const [state] = useAtom(dataStateAtom)


	/* 	const {
		state: {
			data: {
				Four: { Activity: activity },
			},
		},
	} = useAppContext() */
	const [label, setLabel] = useState('')

	useEffect(() => {
		switch (state.data.Four.Activity) {
			case 'T':
			case 'D':
				setLabel('Ultima busta paga')
				break
			case 'A':
				setLabel('Modello unico')
				break
			case 'P':
				setLabel('Certificazione unica')
				break
			default:
				setLabel('Documenti reddituali')
				break
		}
	}, [])

	return label
}
